<template>
	<div data-component="edit-link-deals">
		<div
			v-if="getLinkDeals.length > 0"
			data-element="deals-list"
		>
			<deal
				v-for="deal in getLinkDeals"
				:key="deal.id"
				:deal="deal"
			>
				<template #actions>
					<btn
						@click.native="removeDealFromLink(deal)"
						text="Remove"
						colour="red"
						size="sm"
					/>
				</template>
			</deal>
			<actions
				:actions="getDealsActions"
				size="sm"
				@actionClick="onActionClick"
			/>
		</div>
		<p v-else data-element="list-empty-state">
			List is empty
		</p>
		<actions
			:actions="getActions"
			@actionClick="onActionClick"
			:isWaiting="isWaiting"
		/>
		<general-deals-library
			v-if="dealsLibraryIsVisible"
			:deals="getLinkDeals"
			@addDealToSelection="addDealToLink"
			@removeDealFromSelection="removeDealFromLink"
		/>
		<portal
			to="modal"
			v-if="previewIsVisible"
		>
			<modal-inner
				@close="togglePreview"
				heading="Preview deals"
			>
				<deal-summaries
					:deals="getLinkDeals"
				/>
			</modal-inner>
		</portal>
	</div>
</template>

<script>

	import GeneralDealsLibrary from '@/components/dealLibrary/GeneralDealsLibrary';
	import Deal  from '@/components/dealLibrary/Deal';
	import Btn from '@/components/ui/Btn';
	import Actions from '@/components/ui/Actions';
	import ModalInner from '@/components/ui/modal/ModalInner';
	import DealSummaries from '@/components/diagrams/DealSummaries';
	import actionClick from '@/mixins/actionClick';
	import api from '@/services/api';

	export default {
		components: {
			GeneralDealsLibrary,
			Deal,
			Btn,
			Actions,
			ModalInner,
			DealSummaries
		},
		mixins: [actionClick],
		props: {
			link: {
				type: Object,
				default: undefined
			}
		},
		data: () => ({
			isWaiting: undefined,
			dealsLibraryIsVisible: false,
			previewIsVisible: false
		}),
		computed: {
			getLinkId () {
				return this.link?.id;
			},
			getLinkDealIds () {
				return this.link?.dealIds || [];
			},
			getLinkDeals () {
				return this.link?.deals || [];
			},
			getActions () {
				return {
					primary: [
						{
							text: 'Save',
							actionId: 'saveDeals',
							btnId: 'saveDeals'
						}
					],
					secondary: [
						{
							text: this.dealsLibraryIsVisible ? 'Hide deals library' : 'Browse deals library',
							actionId: 'toggleDealsLibrary',
							btnId: 'toggleDealsLibrary'
						}
					]
				};
			},
			getDealsActions () {
				return {
					primary: [
						{
							text: 'Preview',
							actionId: 'togglePreview',
							btnId: 'togglePreview'
						}
					],
					secondary: [
						{
							text: 'Clear list',
							actionId: 'clearDeals',
							btnId: 'clearDeals'
						}
					]
				};
			}
		},
		methods: {
			toggleDealsLibrary () {
				this.dealsLibraryIsVisible = !this.dealsLibraryIsVisible;
			},
			togglePreview () {
				this.previewIsVisible = !this.previewIsVisible;
			},
			addDealToLink (deal) {
				this.link.deals = [...this.getLinkDeals, deal];
			},
			removeDealFromLink (deal) {
				this.link.deals = this.getLinkDeals.filter(item => item.id !== deal.id);
			},
			clearDeals () {
				this.link.deals = [];
			},
			async saveDeals () {
				this.isWaiting = 'saveDeals';
				const response = await api.dealLinks.updateDealLink({
					link: {
						dealIds: this.getLinkDeals.map(({ id }) => id)
					},
					linkId: this.getLinkId
				});
				this.isWaiting = undefined;
				if (response) {
					this.$store.commit('ui/showNotification', {
						notification: 'The link deals has been saved'
					});
				} else {
					console.error('Something went wrong. Empty response received.');
				}
			}
		}
	};
</script>

<style lang="scss" scoped>

	[data-component='edit-link-deals'] {
		display:flex;
		flex-direction: column;

		[data-element='deals-list'] {
			[data-component='actions'] {
				padding:rem(10) 0;
			}
		}

		[data-element='list-empty-state'] {
			width:100%;
			padding:rem(20) 0;
			font-size:rem(18);
			color:$c-brand-grey;
			text-align:center;
		}
	}

</style>
